
<template>
    <span>{{ translation }}</span>
</template>

<script>
    import translateService from '../repositories/TranslateService';

    export default {
        props: {
            'item': String,
            'fallback': String
        },

        data: function () {
            return {
                translations: translateService.TranslationsDictionary,
            };
        },

        computed: {
            translation: function () {
                return this.translations[this.item] || this.fallback || '[' + this.item + ']'
            }
        }
    }
</script>
